<template>
  <a-layout>
    <!--中间布局 background: '#fff', -->
    <a-layout-content :style="{ background: '#fff', padding: '75px 50px 20px 50px', margin: 0, minHeight: '720px' }">

      <!-- 635*256 -->
      <a-empty :description="'(｡•ˇ‸ˇ•｡) 404未找到页面 ⚆_⚆？'" style="margin-top: 200px;" :image="require('@/assets/404.png')"
        :image-style="{ height: '200px', }" />

    </a-layout-content>
    <!-- 底部 -->
    <the-footer></the-footer>
  </a-layout>

</template>
<script lang="ts">
import { defineComponent, onMounted, ref, createVNode } from 'vue';
import TheFooter from "@/components/the-footer.vue";

export default defineComponent({
  name: 'NotFound',
  components: {
    TheFooter
  },
  setup() {

  }
});
</script>
<style scoped>
.about {
  /* padding: 75px 50px 20px 50px; */
  background: white;
}
</style>
